import EmptyCols from './EmptyCols.component';

export default EmptyCols;
